<script context="module">
  export const filterKey = Symbol();
  export const dropdownSectionKey = Symbol();
</script>

<script lang="ts">
  import { onDestroy } from "svelte";
  import { onMount, setContext } from "svelte";
  import { writable } from "svelte/store";
  import { fly } from "svelte/transition";

  let filter = writable("");
  setContext(filterKey, filter);
  setContext(dropdownSectionKey, writable(0));

  let element: HTMLUListElement;
  let observer: ResizeObserver;
  let minWidth = 0; // this will prevents dropdown from shrinking when filtering the items (see below)

  onMount(() => {
    const setMinWidth = () => {
      if (!element || minWidth > element?.getBoundingClientRect().width) return;
      // we set the minWidth to the width of the dropdown content
      // so that it doesn't shrink when filtering the items
      minWidth = element?.getBoundingClientRect().width;
    };
    observer = new ResizeObserver(setMinWidth);

    observer.observe(element);
  });

  onDestroy(() => {
    observer.disconnect();
  });
</script>

<ul
  class="glossy-effect flex flex-col gap-1 rounded-lg border-[0.5px] border-black/10 p-1 font-medium shadow *:shrink-0 dark:border-white/10 dark:text-white"
  style="min-width:{minWidth}px"
  in:fly={{ y: -8, duration: 60 }}
  bind:this={element}
>
  <slot />
</ul>
